import React, { useEffect, useState } from "react";
import Routes from "./routes/index.routes";
import GlobalStyle from "./styles/";
import AppProvider from "./hooks/";
// import { useClearCache } from 'react-clear-cache';
import CustomButton from "./components/CustomButton";
import CookieConsent from "./CookieConsent";
import { useUtmCapture } from "./utils/captureUtm";

// ISTO É O REGISTRO MANUAL E SIMPLES QUE PRECISO REMOVER PARA A TELA NÃO FICAR BRANCA
/*
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((reg) => console.log("Service Worker registrado:", reg))
      .catch((err) => console.log("Erro no Service Worker:", err));
  });
}
*/

function App() {
  // const { isLatestVersion, emptyCacheStorage } = useClearCache();
  const [installPromptEvent, setInstallPromptEvent] = useState<any>(null);
  const [showInstallPrompt, setShowInstallPrompt] = useState(false);

  const [showUpdatePrompt, setShowUpdatePrompt] = useState(false);
  const [workerRegistration, setWorkerRegistration] = useState<ServiceWorkerRegistration | null>(null);

  // NOVO: useEffect para escutar o evento de nova versão vindo do index.tsx
  useEffect(() => {
    const handleNewVersion = (event: Event) => {
      const registration = (event as CustomEvent<ServiceWorkerRegistration>).detail;
      setShowUpdatePrompt(true);
      setWorkerRegistration(registration);
    };

    window.addEventListener('newVersionReady', handleNewVersion);

    return () => {
      window.removeEventListener('newVersionReady', handleNewVersion);
    };
  }, []);

  // Função para ser chamada pelo botão "Atualizar"
  const handleUpdate = () => {
    if (workerRegistration && workerRegistration.waiting) {
      // Variável de controle para evitar reloads duplicados
      let reloading = false;

      // 1. Adiciona o listener de 'controllerchange'
      // Este evento dispara quando o novo SW (que estava em 'waiting')
      // finalmente assume o controle da página.
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (reloading) return;
        reloading = true;
        // Recarrega a página para usar a nova versão
        window.location.reload();
      });

      // 2. Envia a mensagem para o SW em espera para ele pular a espera
      // Isso fará com que ele se ative e acione o evento 'controllerchange'
      workerRegistration.waiting.postMessage({ type: 'SKIP_WAITING' });
    }
  };

  useEffect(() => {
    const handleBeforeInstallPrompt = (e: any) => {
      e.preventDefault();
      setInstallPromptEvent(e);
      if (
        window.innerWidth < 768 ||
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        setShowInstallPrompt(true);
        setTimeout(() => setShowInstallPrompt(false), 10000);
      }
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    return () =>
      window.removeEventListener(
        "beforeinstallprompt",
        handleBeforeInstallPrompt
      );
  }, []);

  const handleInstallClick = () => {
    if (installPromptEvent) {
      installPromptEvent.prompt();
      installPromptEvent.userChoice.then((choiceResult: any) => {
        setInstallPromptEvent(null);
        setShowInstallPrompt(false);
      });
    }
  };

  useEffect(() => {
    function checkCampaign() {
      const campaignParam = new URLSearchParams(window.location.search);
      if (!!campaignParam.has("campanha")) {
        localStorage.setItem(
          "@7Cantos:Campaign",
          String(campaignParam.get("campanha"))
        );
      }
      if (!!campaignParam.has("canal")) {
        localStorage.setItem(
          "@7Cantos:Channel",
          String(campaignParam.get("canal"))
        );
      }
    }
    checkCampaign();
  }, []);

  useUtmCapture();

  // useEffect(() => {
  //   if (!isLatestVersion) emptyCacheStorage();
  // }, [isLatestVersion, emptyCacheStorage]);

  return (
    <>
      {/* {!!isLatestVersion ? ( */}
      <>
        <CookieConsent />
        <AppProvider>
          <Routes />
        </AppProvider>
        <GlobalStyle />
        {showInstallPrompt && (
          <div
            style={{
              position: "fixed",
              bottom: 0,
              left: 0,
              right: 0,
              backgroundColor: "#fff",
              padding: "10px",
              boxShadow: "0 -2px 10px rgba(0,0,0,0.1)",
              zIndex: 1000,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div>
              <strong>Instale o app 7 Cantos</strong>
              <p>Para uma melhor experiência no seu dispositivo</p>
            </div>
            <div>
              <CustomButton
                onClick={() => setShowInstallPrompt(false)}
                style={{ backgroundColor: "#fff", color: "#666666" }}
              >
                Fechar
              </CustomButton>
              <CustomButton
                onClick={handleInstallClick}
                style={{
                  padding: "5px 15px",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  marginTop: "1rem",
                }}
              >
                Instalar
              </CustomButton>
            </div>
          </div>
        )}

        {/* NOVO: Notificação de atualização */}
        {showUpdatePrompt && (
          <div
            style={{
              position: 'fixed',
              bottom: '20px',
              left: '20px',
              padding: '1em',
              backgroundColor: '#333',
              color: 'white',
              zIndex: 1000,
              borderRadius: '8px',
              boxShadow: '0 4px 8px rgba(0,0,0,0.2)'
            }}
          >
            <p style={{ margin: 0, paddingRight: '1em' }}>Uma nova versão está disponível!</p>
            <CustomButton
              onClick={handleUpdate}
              style={{
                marginTop: '8px'
              }}
            >
              Atualizar
            </CustomButton>
          </div>
        )}
      </>
      {/* ) : null} */}
    </>
  );
}

export default App;
